export const SERVICE_ACCOUNT_NAME_MAX_LENGTH = 254;
const HEAD_TAIL_CHARS = '[a-zA-Z0-9#\\-_.@]';
const MIDDLE_CHARS = '[a-zA-Z0-9#\\-_.@ ]';
export const SERVICE_ACCOUNT_NAME_START_REGEX = new RegExp(`^${HEAD_TAIL_CHARS}`);
export const SERVICE_ACCOUNT_NAME_END_REGEX = new RegExp(`${HEAD_TAIL_CHARS}$`);
export const SERVICE_ACCOUNT_NAME_CONTENT_REGEX = new RegExp(`^${MIDDLE_CHARS}+$`);
export const SERVICE_ACCOUNT_NAME_OPENAPI_REGEX = new RegExp(`^${HEAD_TAIL_CHARS}(${MIDDLE_CHARS}*${HEAD_TAIL_CHARS})?$`);
